import { useState } from 'react';
import type { ReactElement } from 'react';

import Modal from 'components/shared/Modal';
import ShipToRecipientModal from './ShipToRecipientModal';

type Props = {
  show: boolean;
  onClose: () => void;
};

function OutOfTownModal({ show, onClose }: Props): ReactElement {
  const [showShipTo, setShowShipTo] = useState(false);
  const [recipient, setRecipient] = useState(null);

  const shipTo = (rcpt) => {
    onClose();
    setRecipient(rcpt);
    setShowShipTo(true);
  };

  return (
    <>
      <Modal
        show={show}
        onClose={onClose}
        className="c-modal-skip-menu-survey c-header-out-of-town"
        header={<Modal.Header>Headed out of town?</Modal.Header>}
        body={(
          <div className="u-text--center">
            <p className="u-text u-text--md">
              Send this week’s box to another address or friend.
            </p>
            <div className="c-form-group" style={{ margin: '36px 0 20px 0' }}>
              <button
                className="c-button c-button--primary d-block"
                type="button"
                onClick={() => shipTo('me')}
              >
                Send to Another Address
              </button>
            </div>
            <div className="c-form-group" style={{ marginBottom: '16px' }}>
              <button
                className="c-button c-button--primary d-block"
                type="button"
                onClick={() => shipTo('friend')}
              >
                Send to a Friend
              </button>
            </div>
            <button
              type="button"
              onClick={onClose}
              style={{ padding: '0 10px', border: 0, margin: '9.5px 0' }}
            >
              No thanks, I’ll skip this week’s menu
            </button>
          </div>
        )}
      />
      <ShipToRecipientModal
        show={showShipTo}
          // @ts-expect-error TODO: fix null safety
        recipient={recipient}
          // @ts-expect-error TODO: fix null safety
        onRecipientChange={setRecipient}
        onShow={() => setShowShipTo(true)}
        onClose={() => setShowShipTo(false)}
      />
    </>
  );
}

export default OutOfTownModal;
